import React , { forwardRef }from 'react';
import { Input, Label, ErrorText } from '../libName';
// Componente pendiente de migración a react-hook-form

const FormInputFileName = React.forwardRef((props, ref) => {

    const [field, fieldOptions, rest] = splitFormProps(props);

    // Use the useField hook with a field and field options
    // to access field state
    const { meta: { error, isTouched }, getInputProps } = useField(field, fieldOptions);

    const { label, style } = rest;
    return (
        <div style={{ ...style, width: '100%' }}>

            <Input {...getInputProps({ref,...rest })} />
            {isTouched && error && <ErrorText>{error}</ErrorText>}
        </div>
    )
})

// FormInput.defaultProps = {
//         type: "text",
//         className: ""
//     }

// FormInput.propTypes = {
//         name: PropTypes.string.isRequired,
//         placeholder: PropTypes.string,
//         type: PropTypes.oneOf(['text', 'number', 'email', 'password']),
//         className: PropTypes.string,
//         value: PropTypes.any,
//         onChange: PropTypes.func.isRequired
//     }

export default React.memo(FormInputFileName);